import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../@types/RootState';
import { RowData } from './datapoints';

export type EditedFamilyClusterDatapointsState = Record<string, Partial<RowData>>;

const initialState: EditedFamilyClusterDatapointsState = {};

const slice = createSlice({
  name: 'getFamilyClusterModal/editedFamilyClusterDatapoints',
  initialState,
  reducers: {
    SET_EDITED_FAMILY_CLUSTER_DATAPOINTS: (_state, { payload }: PayloadAction<EditedFamilyClusterDatapointsState>) => payload,

    UPDATE_EDITED_FAMILY_CLUSTER_DATAPOINT: (
      state,
      {
        payload,
      }: {
        payload: {
          key: string;
          updatedData: Partial<RowData>;
        };
      },
    ) => {
      state[payload.key] = {
        ...state[payload.key],
        ...payload.updatedData,
      };
    },
    CLEAR_EDITED_FAMILY_CLUSTER_DATAPOINTS: () => initialState,
  },
});

export const { SET_EDITED_FAMILY_CLUSTER_DATAPOINTS, UPDATE_EDITED_FAMILY_CLUSTER_DATAPOINT, CLEAR_EDITED_FAMILY_CLUSTER_DATAPOINTS } = slice.actions;

export const selectorGetEditedFamilyClusterDatapoints = (state: RootState) => state.getFamilyClusterModalReducer.editedFamilyClusterDatapoints;

export default slice.reducer;
